
    <!--
 * 竖版-页面导航
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_92PM131"  v-show="compData.isShow" :class="[`normal`,`u_c_92PM131`]" ><div id="u_c_3IUT132"  v-for="(btnItem, btnI) in compData.btnList" :key="btnI" :class="[`normal`,`u_c_3IUT132`]" ><a id="u_c_1PZ0133" href="javascript:;" :style="`${ btnItem.pic ? `background-image:url(${ btnItem.pic })` : '' }`" :class="[`${ btnItem.cur ? 'cur' : '' }`,`normal btn-light`,`u_c_1PZ0133`]" @click="u_c_1PZ0133_event_F9W931($event,btnI,btnItem.block,btnItem.link)"><div id="u_c_FXUU134"  v-html="pageData.isEdit ? btnItem.text : getBtnText(btnItem)" :class="[`normal`,`u_c_FXUU134`]" ></div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"每日\n首充"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"签到\n获豪礼"},{"pic":"","block":"pay","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"前往\n充值"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"幸运\n抽奖"},{"pic":"","block":"u_c_O87P194","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"奖励\n送不停"}],"isShow":true},"zh-TW":{"btnList":[{"pic":"","block":"u_c_113F49","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"首儲贈禮"},{"pic":"","block":"u_c_2DMU62","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"簽到好禮"},{"pic":"","block":"pay","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"前往儲值"},{"pic":"","block":"u_c_9LBP81","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"中秋賞月禮包"},{"pic":"","block":"u_c_O87P194","link":"https://pay.playplanetgame.com/platform/officialWebStore.html?gameId=379","text":"二重好禮"}],"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const getCurLink = inject("getCurLink", (link) => {})

const init = () => {
  compData.isShow = true;
  if (bridge.runInsdk()) {
    compData.btnList = compData.btnList.filter((item) => {
      return item.block != "pay";
    });
  }
  compData.btnList.forEach((item) => {
    if (item.link) {
      item.link = utils.getStoreLinkWithCidScid({
        link: item.link,
        paramsObj: {
          language: curLang,
          gameId: pageData.gameId,
        },
        pageId: pageData.pageId,
      })
    }
  })
}

init()
// 获取按钮名称
const getBtnText = (item) => {
  if (item.block === "pay") {
    return getLangTxt("goPay");
  }
  if (item.block === "download") {
    return getLangTxt("downloadGame");
  }
  return item.text;
};
let sectionPosition = []
onMounted(() => {
  let curScroll = document.documentElement.scrollTop
  compData.btnList.forEach((item, index) => {
    if (item.block && !["pay", "download"].includes(item.block)) {
      let _ele = document.getElementById(item.block)
      if (_ele) {
        let _p = _ele.getBoundingClientRect()
        sectionPosition.push({
          top: Math.floor(_p.top + curScroll + _p.height / 3),
          realTop: Math.floor(_p.top + curScroll),
          index,
        })
      }
    }
  })
  const throttledFn = vueUse.useThrottleFn(() => {
    let curScroll = document.documentElement.scrollTop
    let curIndex = sectionPosition.findIndex((item) => item.top > curScroll)
    if (~curIndex) {
      compData.btnList.forEach((item, index) => {
        if (index == sectionPosition[curIndex].index) {
          item.cur = 1
        } else {
          item.cur = 0
        }
      })
    }
  })
  window.addEventListener("scroll", throttledFn)
  throttledFn()
});
      // 自定义元素1PZ0133的click事件
      const u_c_1PZ0133_event_F9W931= async (e,index,block,link)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `导航栏-${index}`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

if (!block || ["pay", "download"].includes(block)) {
  bridge.open(link)
} else {
  let curTopIndex = sectionPosition.findIndex(
    (item) => item.index == index
  )
  if (~curTopIndex) {
    window.scrollTo({
      top: sectionPosition[curTopIndex].realTop,
      behavior: "smooth",
    })
  }
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.default{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.default{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307209166-63.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.default{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.zh-TW{
.u_c_92PM131.normal{
position:fixed;
left:50%;
bottom:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
transform:translateX(-50%);

}
}.zh-TW{
.u_c_3IUT132.normal{
position:relative;
display:block;

}
}.zh-TW{
.u_c_1PZ0133.normal{
position:relative;
display:flex;
width:2.00rem;
height:1.52rem;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307209166-63.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_1PZ0133.normal.cur{
filter:brightness(1.4);

}
}.zh-TW{
.u_c_FXUU134.normal{
position:relative;
font-size:0.36rem;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}
</style>
